import apiConfig from "../config/apiConfig";
import { fetchForeignResource } from '../apis/resources';
import { fetchEnum } from '../apis/enum';
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { apiFetch } from "../apis/apiFetch";
import { toast } from "../utils/toast";


export const withdrawalsService = {
  async create(data: any) {
    const res = await apiFetch(apiConfig.getResourceUrl("withdrawals"), {
      method: "POST",
      body: data.params,
    });

    const resJson = await res.json()
    // if (resJson.errCode === -1) alert("Error: " + resJson.message);
    return resJson
  },

  async getData() {
    const response = await apiFetch(
      `${apiConfig.getResourceUrl('withdrawals')}?queryId=GET_ALL`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      throw new Error("Error: " + response.status);
    }

    const data = await response.json();
    return data.resource || [];
  },

  async getMetadata(): Promise<any> {
    const metadataUrl = apiConfig.getResourceMetaDataUrl("Withdrawals");
    const res = await fetch(metadataUrl);
    if (!res.ok) throw new Error("Metadata fetch failed");
    return res.json();
  },

  async getForeignResource(name: string): Promise<any[]> {

    const data = await fetchForeignResource(name);
    return data;
  },

  async update(id: string, base64Resource: string) {
    const formData = new FormData();
    formData.append("resource", base64Resource);

    const response = await apiFetch(
      `${apiConfig.getResourceUrl("withdrawals")}?queryId=MODIFY`,
      {
        method: "POST",
        body: formData,
      }
    );

    const resJson = await response.json();
    console.log("Query update response:", resJson);
    if (resJson.errCode === -1)
      toast.error("Error: " + resJson.message);
    return resJson;
  },

  async getEnum(name: string): Promise<any[]> {

    const data = await fetchEnum(name);
    return data;
  },
};
